import apiSales from '../apiSales';

import { ParamsBodyPostUpdateQuote, ParamsDataPostUpdateQuote, ParamsBodyFilterPostUpdateQuote } from 'utils/typeServices';

type response = {
    errorCode: null;
    message: string;
    success: boolean;
    Data: ParamsDataPostUpdateQuote;
}

export const PostUpdateQuote = async ({ body, bodyFilter }: { body: Array<ParamsBodyPostUpdateQuote>, bodyFilter: ParamsBodyFilterPostUpdateQuote }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiSales.put<response>(`/quote/${bodyFilter.CD_COTACAO}?CD_PESSOA_PARCEIRO=${bodyFilter.CD_PESSOA_PARCEIRO}&CD_PESSOA_PARCEIRO_ESTABELECIMENTO=${bodyFilter.CD_PESSOA_PARCEIRO_ESTABELECIMENTO}&CD_PESSOA_VENDEDOR=${bodyFilter.CD_PESSOA_VENDEDOR}&CD_CANAL_VENDA=${bodyFilter.CD_CANAL_VENDA}`, bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data.Data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
